export default {
	logout({commit}) {
		commit('LOGOUT');
	},

	setToken({ commit }, tokenData) {
		commit('SET_TOKEN', tokenData);
	},

	setRefreshTokens({commit}, payload) {
		commit('SET_TOKENS_FROM_REFRESH', payload);
	},

	setUser({ commit }, user) {
		commit('SET_USER', user);
	},

	setActiveCustomer({ commit }, customer) {
		commit('SET_ACTIVE_CUSTOMER', customer);
	},

	setActiveCompany({ commit }, company) {
		commit('SET_ACTIVE_COMPANY', company);
	},

	setActiveBuilding({commit}, building) {
		commit('SET_ACTIVE_BUILDING', building);
	},

	setLicense({commit}, license) {
		commit('SET_LICENSE', license);
	}
};
